import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    QueryList,
    TemplateRef,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import "rxjs/add/operator/toPromise";
import { fuseAnimations } from "@fuse/animations";
import { StorageService } from "../../../common/service/storage.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Patient } from "../patient";
import { MatDialog } from "@angular/material/dialog";
import { AddPatientDialogComponent } from "../addpatient/add-patient-dialog.component";
import { EditPatientDialogComponent } from "../editpatient/edit-patient-dialog.component";
import { Load } from "../../load/load";
import { ShareAssessmentDialogComponent } from "../shareAssessmentLink/share-assessment-dialog.component";
import { Globals } from "../../../common/global";
import { TeamService } from "../../team/team.service";
import { SuccessfulComponent } from "../successful/successful.component";
import * as moment from "moment";
import { BaseListComponent } from "../../../base/base-list.component";
import { ConfigService } from "../../../common/config/config.service";
import { PatientListService } from "./patient-list.service";
import { ApiService } from "../../../common/service/api.service";
const timeZone = require("moment-timezone");
import { Subscription } from "rxjs";
import { PatientInfiniteScroll } from "./patient-infinite-scroll.service";
import { MatTableDataSource } from "@angular/material/table";
import { Style } from "util";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { PatientService } from "../patient.service";
import { MatPaginator } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";
import { tr } from "date-fns/locale";
import { PatientTableRefreshService } from "../patinet-table-refresh.service";
import { get } from "lodash";

@Component({
    selector: "patient-table",
    templateUrl: "patient.component.html",
    styleUrls: ["patient.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class PatientComponent implements OnInit, OnDestroy, AfterViewInit {
    patient: string;
    navigationType = this.route.snapshot.data.navType;
    // checkHide = this.getSubscriptionType();
    columns = [];
    // columnsConfig = this.getColumnConfig();
    titleMatIcon = this.getTitleMatIcon();
    title = this.getTitle();
    displayedColumns = [];
    // displayedColumnsConfig = this.columnsConfig
    //     .filter((c) => c.hide === false)
    //     .map((c) => c.columnDef);

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;
    isLoading = true;
    alertSign = "";
    enableInfoMsg = false;
    protected extraCta = {
        visibility: false,
        text: "",
    };

    points = [];
    signatureImage;
    staffDropDown: any;
    staffForm: FormGroup;
    staffName = "";

    perPageData = this.global.perPageData;

    token: number;
    queryParam = {};

    isInitComplete = false;
    subscription: Subscription;
    dataN: Array<any> = [];

    tableData: Patient[] = [];
    dataSource = new MatTableDataSource<any>(this.tableData);
    dataSourceFilters = new MatTableDataSource(this.tableData);
    dataSourceWithPageSize = new MatTableDataSource(this.tableData);
    isNextPressed = false;
    todayDate: Date = new Date();
    static oldData: Array<any> = [];
    static cursor: any;
    isMoreDataAvailable = true;
    pmsIntegration: boolean;
    loadingSpinner: boolean = true;
    labConfig: any;
    dateTime: any;
    getCountrycode: any = 0;
    page: number;
    searchTxt: any;
    searchText: any;
    patinetData: Array<any>;
    hasEditDataShown: boolean;
    errorMessage: any;
    isLoginFailed: boolean;
    idTodel: any;
    // countryCode='+91';

    prev: number = 1;
    next: number = 1;
    count: number;
    totalPage: boolean;
    @ViewChild("table") table: ElementRef;
    currentpage: any;
    searchTerm: any;
    isEnterPressed: boolean;
    refDialogNodataFound: boolean;
    pageSize = 10; // Adjust based on your requirement
    totalPages = 0;
    totalItems = 0;
    isSearch: Boolean = false;
    hasMoreData: Boolean = false;
    isFirstSearch: Boolean = true;
    isReloading: boolean = false;
    pms_integration: any;
    patient_force_update: any;
    PAGE_SIZE: number = 10;
    private observer: MutationObserver | null = null;
    overflowFlags: boolean[] = [];
    searchDisabled: boolean = false;
    isDataLoaded: boolean = true;

    constructor(
        private userSevice1Child: StorageService,
        private fb1: FormBuilder,
        private route1: ActivatedRoute,
        private router1: Router,
        private changeDetectorRefs1: ChangeDetectorRef,
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router,
        private paginationService: PatientListService,
        private infiniteScroll: PatientInfiniteScroll,
        private changeDetectorRefs: ChangeDetectorRef,
        public snackBar: MatSnackBar,
        public global: Globals,
        public configService: ConfigService,
        public team: TeamService,
        private httpClient: HttpClient,
        private apiService: ApiService,
        private patientservice: PatientService,
        public translate: TranslateService,
        public tableRefreshService: PatientTableRefreshService,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
    ) {
        // // console.log(e);
    }

    @ViewChild("paginator", { static: true }) paginator: MatPaginator;
    // @ViewChild('paginator') paginator: MatPaginator;
    @ViewChild("paginatorPageSize", { static: true })
    paginatorPageSize: MatPaginator;
    // @ViewChild('empTbSort') empTbSort = new MatSort();
    // @ViewChild(MatSort, {static: true}) sort: MatSort;

    pageSizes = [10];

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSourceWithPageSize.paginator = this.paginatorPageSize;
        const table: HTMLElement | null =
            this.el.nativeElement.querySelector("mat-table");
        if (!table) return;

        this.observer = new MutationObserver((mutations) => {
            if (!this.isNextPressed) return;

            const rows = table.querySelectorAll(".mat-row");
            if (rows.length > 0) {
                const last = rows[rows.length - 1] as HTMLElement;
                last.scrollIntoView({ behavior: "smooth", block: "end" });
                this.isNextPressed = false;
            }
        });

        this.observer.observe(table, { childList: true, subtree: true });
    }
    /**
     * On init
     */
    ngOnInit(): void {
        this.pms_integration = localStorage.getItem("pms_integration");
        this.patient_force_update = localStorage.getItem(
            "patient_force_update",
        );
        this.refDialogNodataFound = false;
        this.tableData = [];
        this.dataSource.data = [];
        this.hasEditDataShown = false;
        this.loadingSpinner = false;
        this.isLoading = true;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        // console.log("next: ", this.next, "prev: ", this.prev);
        // console.log(this.pms_integration);

        const keys = [
            "Common.Sr",
            "Patients.FirstName",
            "Patients.LastName",
            "Patients.PatientID",
            "Patients.email",
            "Patients.MobileNumber",
            "Patients.DateOfBirth",
            "Patients.edit",
            "Patients.delete",
            "Patients.view",
        ];
        this.translate.onLangChange.subscribe(() => {
            this.translate.get(keys).subscribe((translations) => {
                this.columns = this.getColumn(translations);
                this.displayedColumns = this.columns.map((c) => c.columnDef);
            });
        });

        this.translate.get(keys).subscribe((translations) => {
            this.columns = this.getColumn(translations);
            this.displayedColumns = this.columns.map((c) => c.columnDef);
        });

        this.subscription = this.tableRefreshService.refresh$.subscribe(() => {
            this.loadTableData();
        });

        this.getallpatient(1);
    }

    getallpatient(page) {
        this.patientservice.getAllpatient(page).subscribe(
            (a) => {
                //    // // console.log(a);
                Object.entries(a).find(([key, value]) => {
                    if (key == "message" && value == "No data Found") {
                        // // console.log(");
                        this.totalPage = true;
                        this.hasEditDataShown = true;
                        this.loadingSpinner = true;
                        this.isDataLoaded = true;
                    }

                    if (key == "data") {
                        this.patinetData = value;
                        this.hasMoreData =
                            this.patinetData.length === this.PAGE_SIZE;
                        if (!this.hasMoreData && this.isNextPressed) {
                            this.openSnackBar(
                                this.translateSentence(
                                    "Common.noFurtherDataAvailable",
                                ),
                                this.translateSentence("Common.ok"),
                            );
                        }
                        //  // // console.log(a);
                        this.refDialogNodataFound = false;
                        this.patinetData.forEach((el) => {
                            //  // // console.log(h);
                            this.tableData.push({
                                patient_id: el.patient_id,
                                first_name: el.first_name,
                                last_name: el.last_name,
                                mobile_number: el.mobile_number,
                                date_of_birth: el.date_of_birth,
                                comboId: "",
                                _id: el._id,
                                email_id: el.email_id,
                                doa: this.currentpage,
                                countryCode: "",
                                dobString: "",
                                deleted: el.deleted,
                            });
                            this.hasEditDataShown = true;
                            this.loadingSpinner = true;
                            this.isDataLoaded = true;
                        });
                    } else {
                        if (key == "status" && value == "failed") {
                            const msg =
                                this.translateSentence("Common.noDataFound");
                            this.openSnackBar(
                                msg,
                                this.translateSentence("Common.ok"),
                            );
                            // this.clearInputSearch();
                            // window.location.reload();
                        }
                    }
                });
                // // // console.log(a);

                this.dataSource.data = this.tableData;
                // console.log(this.patinetData);

                // this.totalItems = this.tableData.length;
                // this.totalPages = Math.ceil(this.totalItems / this.pageSize);
                // this.hasMoreData = this.totalItems === this.pageSize;

                //  // // console.log(a);
            },

            (err) => {
                this.errorMessage = err.error.message;
                this.isLoginFailed = true;
            },
        );
    }

    onKeyDown(event: KeyboardEvent): void {
        const trimmedText = this.searchText ? this.searchText.trim() : "";
        const inputElement = event.target as HTMLInputElement;
        const sanitizedValue = inputElement.value;
        inputElement.value = sanitizedValue;
        this.searchText = sanitizedValue;
        if (event.key === "Backspace") {
            if (trimmedText.length === 0 && !this.isReloading) {
                this.clearInputSearch();
                this.isReloading = true;
            }
        } else {
            this.isReloading = false;
        }
    }

    onClickSearch(searchText) {
        this.hasEditDataShown = false;
        this.loadingSpinner = false;
        this.isSearch = true;
        this.searchDisabled = true;
        this.isDataLoaded = false;
        const sanitizedText = searchText.trim();

        // console.log("next: ", this.next, "prev: ", this.prev);

        // // console.log(t);
        this.patientservice.searchPatient(sanitizedText, this.next).subscribe(
            (a) => {
                // // console.log(a);
                Object.entries(a).find(([key, value]) => {
                    if (key == "message" && value == "No data Found") {
                        this.totalPage = true;
                        this.hasEditDataShown = true;
                        this.loadingSpinner = true;
                        this.searchDisabled = false;
                        this.isDataLoaded = true;
                        // this.getallpatient(1);
                        // this.refDialogNodataFound = true;
                        // this.openDialogWithRefNodatafound(refDialogNodataFound)
                    }
                    if (key == "data") {
                        this.patinetData = value;

                        this.hasMoreData =
                            this.patinetData.length === this.PAGE_SIZE;
                        if (!this.hasMoreData && this.isNextPressed) {
                            this.openSnackBar(
                                this.translateSentence(
                                    "Common.noFurtherDataAvailable",
                                ),
                                this.translateSentence("Common.ok"),
                            );
                        }

                        this.patinetData.forEach((el) => {
                            //  // // console.log(h);
                            this.tableData.push({
                                patient_id: el.patient_id,
                                first_name: el.first_name,
                                last_name: el.last_name,
                                mobile_number: el.mobile_number,
                                date_of_birth: el.date_of_birth,
                                comboId: "",
                                _id: el._id,
                                email_id: el.email_id,
                                doa: this.currentpage,
                                countryCode: "",
                                dobString: "",
                                deleted: el.deleted,
                            });
                            this.hasEditDataShown = true;
                            this.loadingSpinner = true;
                            this.searchDisabled = false;
                            this.isDataLoaded = true;
                        });
                    } else {
                        // // console.log(e);
                        if (key == "status" && value == "failed") {
                            const msg =
                                this.translateSentence("Common.noDataFound");
                            this.openSnackBar(
                                msg,
                                this.translateSentence("Common.ok"),
                            );
                            // this.clearInputSearch();
                            // window.location.reload();
                        }

                        // this.hasEditDataShown = true;
                        // this.loadingSpinner = true;
                    }
                });
                // // // console.log(a);

                this.dataSource.data = this.tableData;
                //  // // console.log(a);
            },

            (err) => {
                this.errorMessage = err.error.message;
                this.searchDisabled = false;
                this.isDataLoaded = true;
                this.isLoginFailed = true;
            },
        );
    }

    handleSearchPatient(searchText) {
        if (!searchText || !searchText.trim()) {
            this.openSnackBar(
                this.translateSentence("Common.noSearchValueAvailable"),
                this.translateSentence("Common.ok"),
            );
            return;
        }
        this.next = 1;
        this.prev = 0;
        this.totalPage = false;
        this.isNextPressed = false;
        this.tableData = [];
        this.dataSource.data = [];
        this.patinetData = [];
        this.onClickSearch(searchText);
    }

    clearInputSearch() {
        this.searchText = "";
        this.isSearch = false;
        this.totalPage = false;
        this.searchDisabled = false;
        this.isDataLoaded = false;
        this.next = 1;
        this.prev = 0;
        this.ngOnInit();
    }

    getRowBackgroundColor(element): string {
        return "#FFFFFF";
    }

    getRowFontColor(element) {
        if (element.deleted == true) {
            return "italic";
        } else return "bold";
    }

    getFontColor(element) {
        if (element.deleted == true) {
            return "#808080";
        } else return "#000000";
    }
    getCrossWord(element) {
        if (element.deleted == true) {
            return "line-through";
        } else return "overline";
    }

    getColumn(translations: { [key: string]: string }): any[] {
        return [
            {
                columnDef: "Sr",
                header: translations["Common.Sr"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    `${this.page * 10 + index + 1}`,
            },
            {
                columnDef: "First Name",
                header: translations["Patients.FirstName"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    `${element.first_name ? element.first_name : ""}`,
            },
            {
                columnDef: "Last Name",
                header: translations["Patients.LastName"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    `${element.last_name ? element.last_name : ""}`,
            },
            {
                columnDef: "ID",
                header: translations["Patients.PatientID"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    `${element.patient_id}`,
            },

            {
                columnDef: "Email",
                header: translations["Patients.email"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    this.replaceWithX(element.email_id ? element.email_id : ""),
            },
            {
                columnDef: "mobileNumber",
                header: translations["Patients.MobileNumber"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    this.replaceWithMob(element.mobile_number),
            },
            {
                columnDef: "dob",
                header: translations["Patients.DateOfBirth"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    `${
                        element.date_of_birth
                            ? element.date_of_birth
                            : this.changeTimestampToDate(element.date_of_birth)
                    }`,
            },
            {
                columnDef: "Action",
                header: translations["Patients.edit"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    `${element.patient_id}`,
            },
            {
                columnDef: "Delete",
                header: translations["Patients.delete"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    `${element.patient_id}`,
            },

            {
                columnDef: "View",
                header: translations["Patients.view"],
                hide: false,
                cell: (element: Patient, index: number) =>
                    this.preparePatientId(
                        element.patient_id,
                        element.first_name,
                        element.last_name,
                    ),
            },
        ];
    }

    getStringOrDefault(reqkey: any, defaulvalue: any) {
        const rg = defaulvalue;
        try {
            if (reqkey === undefined || reqkey === null) {
                return defaulvalue;
            } else {
                return reqkey;
            }
        } catch (error) {
            rg == defaulvalue;
        }
    }

    replaceWithMob(mob) {
        mob = this.getStringOrDefault(mob, "");
        const mobileNo = mob.toString();
        // // // console.log(o);
        if (mobileNo !== undefined) {
            const mob = mobileNo.replace(/[^0-9]/g, "");
            // // // console.log(b);
            const patt = /^[0-9]\d*$/;
            if (mob && patt.test(mob)) {
                const txt = mob.toString();
                let numb = txt.match(/\d/g);
                numb = numb.join("");
                if (numb.length < 3) {
                    return numb;
                }
                return (
                    numb[0] +
                    new Array(numb.length - 2).join("*") +
                    numb[numb.length - 2] +
                    numb[numb.length - 1]
                );
            } else {
                return "";
            }
        } else {
            return "-";
        }
    }

    replaceWithX(email) {
        let beforeText = "";
        const beforeAtTheRate = email.split("@")[0];
        const afterAtTheRate = email.split("@")[1];
        if (beforeAtTheRate) {
            if (beforeAtTheRate.length >= 3) {
                beforeText =
                    beforeAtTheRate[0] +
                    new Array(beforeAtTheRate.length - 1).join("*") +
                    beforeAtTheRate[beforeAtTheRate.length - 1];
            } else if (beforeAtTheRate.length === 2) {
                beforeText = "**";
            } else {
                beforeText = "*";
            }
            return beforeText.concat("@").concat(afterAtTheRate);
        }
    }

    prepareComboId(id, fname, lname, mobile) {
        let combo = "";
        if (mobile) {
            combo =
                "patient#" +
                id +
                "##firstName#" +
                fname +
                "##lastName#" +
                lname +
                "##mobile#" +
                mobile;
        } else {
            combo =
                "patient#" +
                id +
                "##firstName#" +
                fname +
                "##lastName#" +
                lname;
        }

        return combo;
        // return combo = combo.replace(/\s/g, '').toLowerCase();
    }

    preparePatientId(id, fname, lname) {
        const patientId =
            "patient#" + id + "##firstName#" + fname + "##lastName#" + lname;
        return patientId;
        // return combo = combo.replace(/\s/g, '').toLowerCase();
    }

    updateRow(row): any {
        // setDeriveFields(row);
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    getTitleMatIcon(): string {
        return "accessibility";
    }

    getTitle(): string {
        return "Patients";
    }

    getSearchText(): string {
        return "Search Patient via name";
    }

    extraButtonClick(): void {
        this.searchTxt = "";
        const dialogRef = this.dialog.open(AddPatientDialogComponent, {
            disableClose: true,
            width: "350px",
            data: { id: "1", firstName: "", lastName: "" },
        });

        dialogRef.beforeClosed().subscribe((bfrC) => {});
        dialogRef.afterClosed().subscribe((result) => {});
    }

    addZeroToHourAndMinutes(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        const strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
    }

    getMapValue(stringData) {
        const param = stringData.replace(/[^a-zA-Z0-9]/g, "");
        const obj = {};
        for (let j = 0; j <= param.length - 1; j++) {
            let emptyString = "";
            for (let k = 0; k <= j; k++) {
                emptyString += param[k];
            }

            obj[emptyString] = true;
        }
        return obj;
    }

    toUpperCaseString(str) {
        return str.trim().toUpperCase();
    }

    editButtonClick(comboId): void {
        // // console.log(d);
        const dialogRef = this.dialog
            .open(EditPatientDialogComponent, {
                width: "350px",
                data: { id: "", firstName: "", lastName: "", comboId: comboId },
            })
            .afterClosed()
            .subscribe((data) => {
                // // console.log(a);
                this.page = 0;
            });
    }

    openDialogWithRefDel(ref: TemplateRef<any>, id): void {
        // // console.log(d);
        this.idTodel = id;
        this.dialog.open(ref, { width: "400px" });
    }

    openDialogWithRefNodatafound(ref: TemplateRef<any>): void {
        // // console.log(d);
        // this.idTodel = id;
        this.dialog.open(ref, { width: "400px" });
    }

    deleteTeamMember(docId) {
        // // console.log(d);
        this.hasEditDataShown = false;
        this.loadingSpinner = false;
        this.patientservice
            .deletePatientFromLab(
                docId,
                this.userSevice1Child.getCookie("lab_id"),
            )
            .subscribe((data) => {
                // // console.log(a);
                Object.entries(data).find(([key, value]) => {
                    if (
                        key == "status" &&
                        (value == "success" || value == "Success")
                    ) {
                        const msg = this.translateSentence(
                            "Patients.PatientDeleteSuccessfully",
                        );
                        this.openSnackBar(
                            msg,
                            this.translateSentence("Common.ok"),
                        );

                        this.tableData = [];
                        this.dataSource.data = [];
                        this.hasEditDataShown = false;
                        this.loadingSpinner = false;
                        this.isLoading = true;
                        this.prev = 0;
                        this.next = 1;
                        this.page = 1;
                        this.count = 1;

                        this.ngOnInit();
                    } else {
                    }
                });
            });
    }

    // onNextPress() {
    //     this.hasEditDataShown = false;
    //     this.loadingSpinner = false;
    //     this.isLoading = true;
    //     this.isNextPressed = true;
    //     this.count = this.count + 1;
    //     this.next = this.prev + 1;
    //     this.prev = this.next - 1
    //     this.page++
    //     this.getallpatient(this.next)
    //     // // console.log(v);
    //     this.next++
    //     this.prev++
    //     this.scrollToBottom();
    // }

    onNextPress() {
        this.hasEditDataShown = false;
        this.loadingSpinner = false;
        this.isLoading = true;
        this.isNextPressed = true;
        this.count = this.count + 1;
        this.next = this.prev + 1;
        this.prev = this.next - 1;
        this.next++;
        this.prev++;
        if (this.isSearch) {
            this.onClickSearch(this.searchText);
        } else {
            this.getallpatient(this.next);
        }
        // this.scrollToBottom();
        // // console.log(t);

        // // console.log(v);
    }

    onPrevPress() {
        this.hasEditDataShown = false;
        this.loadingSpinner = false;
        this.count = this.count - 1;
        this.prev = this.next - 1;
        this.prev--;
        this.next--;
        this.page--;
        this.getallpatient(this.prev);
        // // console.log(t);
    }

    scrollToBottom(): void {
        if (this.isNextPressed) {
            this.isNextPressed = false;
            const table = document.querySelector("mat-table");
            table.scrollBy({
                behavior: "smooth",
                left: 0,
                top: table.scrollHeight,
            });
        }
    }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }

    private handleError(error: Error): void {
        // this.openSnackBar(error.message, "OK");
        // this.notify.update(error.message, 'error');
    }

    viewHistory(patientId) {
        let addSearchText = "";
        if (this.searchText) {
            addSearchText = patientId + "##searchTxt#" + this.searchText;
        } else {
            addSearchText = patientId;
        }

        this.router.navigate(["/patientdetail"], {
            queryParams: { token: this.global.encodeToa(addSearchText) },
        });
    }

    openDialogWithRef(ref: TemplateRef<any>, comboId, emailId) {
        this.dialog.open(ref, {
            disableClose: true,
            height: "250px",
            width: "350px",
        });
    }

    openSuccessfulDialog() {
        const dialogRef = this.dialog.open(SuccessfulComponent, {
            disableClose: true,
            width: "350px",
            height: "250px",
        });
    }

    changeTimestampToDate(timestamp) {
        if (timestamp) {
            return moment(timestamp).format("DD/MM/YYYY");
        }
        return "";
    }

    @HostListener("document:keypress", ["$event"])
    handleKeyboardEvent(event: KeyboardEvent) {
        this.handleEnterSearch(event);
    }

    handleEnterSearch(event: KeyboardEvent) {
        if (
            event.key.includes("Enter") &&
            event.code.includes("Enter") &&
            document.activeElement.id.includes("search")
        ) {
            this.isEnterPressed = true;
            this.searchDisabled = false;
            if (this.searchText && this.searchText.length > 0) {
                this.handleSearchPatient(this.searchText);
            }
        } else {
            this.isEnterPressed = false;
        }
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    loadTableData() {
        this.tableData = [];
        this.dataSource.data = [];
        this.patinetData = [];
        this.hasEditDataShown = false;
        this.loadingSpinner = false;
        this.isLoading = true;
        this.searchDisabled = false;
        this.isSearch = false;
        this.hasMoreData = true;
        this.searchText = "";
        this.isNextPressed = false;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        this.getallpatient(1);
    }

    // getSubscriptionType() {
    //     // // console.log(e);
    //     switch (this.navigationType) {
    //         case "screening":
    //             return true;
    //         default:
    //             return false;
    //     }
    // }

    // nextPage() {
    //     this.hasEditDataShown = false;
    //     this.loadingSpinner = false;
    //     this.isLoading = true;
    //     this.page++;
    //     this.getallpatient(this.page);
    // }

    // prevPage() {
    //     this.hasEditDataShown = false;
    //     this.loadingSpinner = false;
    //     this.isLoading = true;
    //     if (this.page > 0) {
    //         this.page--;
    //         this.getallpatient(this.page);
    //     }
    // }
}
